import { render, staticRenderFns } from "./AdminsOverview.vue?vue&type=template&id=94cca31e"
import script from "./AdminsOverview.vue?vue&type=script&lang=js"
export * from "./AdminsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports